<template>
  <div class='button_div'>
    <button :class="{ disabled_btn: isDisabled, btn: !isDisabled }" @click="viewDelete()"
      :disabled="isDisabled">刪除</button>
  </div>
</template>

<script>
import {
  onMounted,
  ref
} from 'vue';
import {
  useRouter
} from 'vue-router';
import {
  Inventory_Delete_Status,
} from '@/assets/js/enter_status'
export default {
  props: ['params'],
  setup(props) {
    const router = useRouter();
    const Status = props.params.data.PlanStatus;
    const search_id = props.params.data.PlanId;
    const isDisabled = ref(false);
    onMounted(() => {
      checkButton();
    });
    function viewDelete() {
      router.push({
        name: 'Inventory_Delete',
        query: {
          search_id
        }
      });
    }
    function checkButton() {
      if (!Inventory_Delete_Status.includes(Status)) {
        isDisabled.value = true;
      }
    }
    return {
      viewDelete,
      isDisabled,
    }
  }
}
</script>


<style lang="scss" scoped>
@import '@/assets/css/global.scss';

.button_div {
  display: flex;
  align-items: center;

  .btn {
    @include content_delete_button;
    height: 25px;

    &:hover {
      background: #FF7272
    }
  }

  .disabled_btn {
    @include disabled_btn;
    height: 25px;
    width: 50px;

    &:hover {
      @include disabled_btn;
      height: 25px;
      width: 50px;
    }
  }
}</style>